class EventBus
{
    constructor()
    {
        this.events = {};
    }

    broadcast(event, execution, data)
    {
        if (!this.events[event])
            return;

        this.events[event].forEach(listener => listener(execution, data));
    }

    subscribe(event, listener)
    {
        if (!this.events[event])
            this.events[event] = [];

        this.events[event].push(listener);
    }

    unsubscribe(event, listener)
    {
        if (!this.events[event])
            return;

        const index = this.events[event].indexOf(listener);

        if (index === -1)
            return;

        this.events[event].splice(index, 1);
    }
};

window.eventBus = new EventBus();

class EventTrigger extends HTMLElement
{
    connectedCallback()
    {
    }

    disconnectedCallback()
    {
    }

    trigger(execution, data)
    {
        data = data || {};

        if (Object.keys(this.dataset).length > 0 && typeof data === "object")
        {
            for (const key in this.dataset)
                data[key] = this.dataset[key];
        }

        eventBus.broadcast(this.getAttribute("event"), execution, data);
    }
}

class EventListener extends HTMLElement
{
    constructor()
    {
        super();

        this._listener = null;
    }

    connectedCallback()
    {
        const eventName = this.getAttribute("event");

        this.listener = (execution, data) => this.process(execution, this, data);

        eventBus.subscribe(eventName, this.listener);
    }

    disconnectedCallback()
    {
        const eventName = this.getAttribute("event");

        eventBus.unsubscribe(eventName, this.listener);
    }

    get listener()
    {
        return this._listener;
    }

    set listener(value)
    {
        this._listener = value;
    }

    // Check if this listener should process the event
    shouldProcess(data)
    {
        // Check for "only-when" attribute (e.g., only-when="modal:true")
        const onlyWhen = this.getAttribute("only-when");

        if (onlyWhen && !this.evaluateCondition(onlyWhen, data))
            return false;

        // Check for "skip-when" attribute (e.g., skip-when="quickadd:true")
        const skipWhen = this.getAttribute("skip-when");

        if (skipWhen && this.evaluateCondition(skipWhen, data))
            return false;

        return true;
    }

    // Evaluate condition expressions
    evaluateCondition(condition, data)
    {
        if (!condition || !data)
            return false;

        // Support multiple conditions separated by comma: "quickadd:true,modal:false"
        const conditions = condition.split(',').map(c => c.trim());

        for (const cond of conditions)
        {
            const [key, value] = cond.split(':').map(s => s.trim());
            
            if (!key)
                continue;

            const dataValue = data[key];
            
            // Handle boolean comparisons
            if (value === 'true' && (dataValue === true || dataValue === 'true'))
                return true;

            if (value === 'false' && (dataValue === false || dataValue === 'false'))
                return true;
            
            // Handle exact value comparisons
            if (dataValue == value)
                return true;
        }

        return false;
    }

    process(execution, listener, data)
    {
        const executionType = listener.getAttribute("execution");

        if (execution != executionType)
            return;

        // Check if listener should process this event
        if (!this.shouldProcess(data))
            return;

        const type = listener.getAttribute("type");

        switch (type)
        {
            case "Load":
                listener.loadHtml(data);
                break;

            case "Run":
                listener.runScript(data);
                break;
        }
    }

    loadHtml(data)
    {
        let url = this.getAttribute("url");
        const targetSelector = this.getAttribute("target");
        const targetType = this.getAttribute("target-type");
        const appendQueryParameters = this.getAttribute("query-parameters");

        if (appendQueryParameters && appendQueryParameters.toString().toLowerCase() === "true")
        {
            var queryParameters = new URLSearchParams(data).toString();

            url += "?" + queryParameters;
        }

        fetch(url)
            .then(response => response.text())
            .then(html =>
            {
                var target = document.querySelector(targetSelector);

                if (targetType == "Parent")
                    target.innerHTML = html;
                else if (targetType == "Self")
                    target.outerHTML = html;

                var customEvent = new CustomEvent("onElementContentChanged", { detail: { target: targetSelector, node: target } });

                document.dispatchEvent(customEvent);

                images.load();
            })
            .catch(error =>
            {
                console.error('Failed to load: ' + url + " - ", error);
            });
    }

    runScript(data)
    {
        const target = this.getAttribute("target");

        var result = new Function("data", target);

        result(data);
    }
}

customElements.define("event-trigger", EventTrigger);
customElements.define("event-listener", EventListener);

//export default eventbus;